import useLayerListeners from './useLayerListeners';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import { Ref, WatchStopHandle } from 'vue';
import { LAYER_CONFIG_OMIT_PROP } from '../constants';

export default function usePolylineLayer(mapInstance: LooseObject, layerInfo: Ref<MapLayer<PolylineLayerConfig>>) {
  if (!layerInfo.value || !layerInfo.value.config) return;

  const { id: layerId } = layerInfo.value;

  let polylineStyle;
  let geometries;
  let unwatchList: WatchStopHandle[] | null = [];


  const polylineLayer = new TMap.MultiPolyline({
    id: layerId,
    map: mapInstance,
  });

  unwatchList.push(watchEffect(() => {
    const styleConfig = omit(layerInfo.value.config, LAYER_CONFIG_OMIT_PROP);
    const styleOption = mapValues(styleConfig, val => toRaw(unref(val)));
    polylineStyle = new TMap.PolylineStyle(styleOption);
    if (polylineLayer) polylineLayer.setStyles({ polylineStyle });
  }));

  unwatchList.push(watchEffect(() => {
    if (!Array.isArray(layerInfo.value.config.data)) return;
    try {
      geometries = layerInfo.value.config.data.map((geometry: PolylineGeometry, index: number) => {
        const { id, paths, rank, properties } = geometry;
        const polylineGeometriesList: PolylineGeometry['paths'] = [];
        paths.forEach((item) => {
          if (!Array.isArray(item)) {
            polylineGeometriesList.push(new TMap.LatLng(item.lat, item.lng));
          } else {
            polylineGeometriesList.push(item.map(child => new TMap.LatLng(child.lat, child.lng)) as LatLng[]);
          }
        });

        return {
          id: id ? id : `${index}`,
          paths: polylineGeometriesList,
          rank: rank ? rank : index,
          styleId: 'polylineStyle',
          properties,
        };
      });
      if (polylineLayer) polylineLayer.setGeometries(geometries);
    } catch (error) {
      polylineLayer?.setGeometries([]);
    }
  }));

  // 用户传入的事件回调在这里处理
  unwatchList.push(watchEffect(() => {
    useLayerListeners(polylineLayer, [
      { eventName: 'click', callbackList: layerInfo.value.config.onClick },
      { eventName: 'hover', callbackList: layerInfo.value.config.onHover },
    ]);
  }));

  polylineLayer.unmount = (): void => {
    polylineLayer?.destroy();
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };

  return polylineLayer;
}
